module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "preface"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('em', [_vm._v("In every espionage operation there is an above the line and a below the line. Above the line is what you do by the book. Below the line is how you do the job")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', [_vm._v("John le Carré")]), _vm._v(", A Perfect Spy")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efb9dfbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312375942_epub_fm_r1.vue
// module id = 75
// module chunks = 0